// react components

// react-router-dom components

// mui components
import { experimentalStyled as styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";

// mui-icons components

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

//routes

//assets

const Box = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
}));

function Item({ children = <></> }) {
    return <Box>{children}</Box>;
}

// Typechecking props for the Item
Item.propTypes = {
    children: PropTypes.object,
};

export default Item;
